
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/system/getting-started/the-sx-prop",
      function () {
        return require("private-next-pages/system/getting-started/the-sx-prop.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/system/getting-started/the-sx-prop"])
      });
    }
  